import { render, staticRenderFns } from "./CreateAccountForm.vue?vue&type=template&id=c58e1c44&scoped=true&"
import script from "./CreateAccountForm.vue?vue&type=script&lang=js&"
export * from "./CreateAccountForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountForm.vue?vue&type=style&index=0&id=c58e1c44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58e1c44",
  null
  
)

export default component.exports